import React, { useState, useEffect } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { OverlayTrigger, Tooltip, Modal, Card, Collapse, Table } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import * as action from '../store/BOMConfig.action';
import { shortenString, shortenStringWithTooltip, hoverTooltip, checkArray, downloadFileFromUrl } from '../../../../Components/helper';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';
import * as colourAction from '../../../Library/ColorLibary/store/ColorLibrary.action';
import { fetchTierSSupplierListAction } from '../../../Supplier/store/Supplier.action';
import NewApproveRejectFooter from '../../../../Components/ApproveRejectFooter/NewApproveRejectFooter';
import noImage from '../../../../assets/images/no-image.png';
import { getSupportingDocuments } from '../../../../Components/SupportingDocument/store/SupportingDocument.action';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import FilePreview from '../../../../Components/FilePreview/FilePreview';
import { getAllUnitDetails } from '../../../SystemMasters/Store/SystemMasters.action';
import './BomExpand.css';

const dateFormat = 'DD-MMMM-YYYY hh:mm A';

const highlightedField = 'highlighted-field';
const LOCALLY_SOURCED = 'Locally Sourced';

const createdBY = (state) => {
  return state?.createdBy && state.createdAt ? (
    <span>
      {' '}
      {state.createdBy} {moment(state.createdAt).format(dateFormat)}{' '}
    </span>
  ) : (
    ''
  );
};

const statusText = () => {
  return 'Rejected';
};

const statusColour = (item) => {
  return item?.status === 0 ? 'red' : '';
};

const textValueCondition = (ele) => {
  return ele || '';
};

const textNoValueCondition = (ele) => {
  return ele || '';
};

const textWithHoverCondition = (ele) => {
  return ele ? hoverTooltip(ele) : '';
};
const handleImageError = (event) => {
  event.target.src = noImage;
};
const imgSrc = (ele, colorLibList) => {
  const findColourwasy = colorLibList?.find((vl) => vl?._id === ele?.colorName?._id);

  return !isEmpty(findColourwasy) && findColourwasy?.image ? (
    <img alt={findColourwasy?.name} onError={handleImageError} src={findColourwasy?.image} />
  ) : (
    <img alt="" src={noImage} />
  );
};

const joinedColourRef = (ele) => {
  return ele?.colourRef?.name && `${ele?.colourRef?.name} | ${ele?.colourRef?.newReferences}`;
};

const colourClassName = (item) => {
  return item?.status === 1 ? 'green' : statusColour(item);
};

const src = (state) => {
  return state?.image || noImage;
};

const forCombinationSupps = (state, joinCombinationSupps) => {
  return !isEmpty(state?.combinationSuppliers) && state !== null ? joinCombinationSupps(state?.combinationSuppliers) : '';
};

const forBomSupps = (state, joinbomSupps) => {
  return !isEmpty(state?.BOMSupplier) && state !== null ? joinbomSupps(state?.BOMSupplier) : '';
};

function BomExpand({ show, handleClose, selectedExpand, selectedTab, devOrderId, suppliersList, updateList, showApprovedReject, showColorWayCheckBox }) {
  const dispatch = useDispatch();
  const reducer = useSelector((states) => states);
  const { BOMConfigDetails, UserDetails, Users, ColorLibraryDetails, SystemMastersDetails, SupportingDocument, SuppliersDetails } = reducer;
  const { isProductArchived } = BOMConfigDetails;
  const { isSupplierLoggedIn, userInfo } = UserDetails;
  const { logInRights } = Users;
  const { CheckActionPermission } = useComponent();
  const loggedInUserId = userInfo.userId;
  const { supportingDocs } = SupportingDocument;
  const { tier2Suppliers, tier3Suppliers, tier4Suppliers } = SuppliersDetails || {};
  const { t } = useTranslation('common');

  const [state, setState] = useState(null);
  const [currentab, setCurrentab] = useState(null);
  const [supplierCollection, setSupplierCollection] = useState([]);
  const [selectedColors, setselectedColors] = useState([]);
  const [disabledSaveBtn, setDisabledSaveBtn] = useState(true);
  const [btnsDisable, setBtnsDisable] = useState(false);
  const [isSubBomOpen, setIsSubBomOpen] = useState(false);
  const [isProductImpactOpen, setIsProductImpactOpen] = useState(false);
  const [isSupportingOpen, setIsSupportingOpen] = useState(false);
  const [supportingDocsList, setSupportingDocsList] = useState([]);
  const [loadingDocs, setLoadingDocs] = useState(false);
  const [showFilePreviewModal, setFilePreviewModal] = useState(false);
  const [selectedFileToPreview, setFileToPreview] = useState(null);
  const { ColorLibList } = ColorLibraryDetails;
  const colorLibList = ColorLibList;
  const { placement_master, finalList, unitList } = SystemMastersDetails || {};

  const BomApproveRejectAccess = CheckActionPermission(logInRights, 'products', 'bom', 'approveReject');
  const colourwayExist = selectedExpand?.colourWayRefsData?.filter((ele) => ele.colourWayId !== null);

  useEffect(() => {
    const callFn = async () => {
      await dispatch(colourAction.fetchColorLibrary({ loggedInUserId }));
    };
    if (loggedInUserId) callFn();
  }, [dispatch, loggedInUserId]);

  useEffect(() => {
    const fetchTierSuppliers = async () => {
      if (show && state?.productImpact) {
        await Promise.all([
          dispatch(fetchTierSSupplierListAction({ isWithFactory: true, tierType: 'Tier2' })),
          dispatch(fetchTierSSupplierListAction({ isWithFactory: true, tierType: 'Tier3' })),
          dispatch(fetchTierSSupplierListAction({ isWithFactory: true, tierType: 'Tier4' })),
        ]);
      }
    };
    fetchTierSuppliers();
  }, [show, state?.productImpact, dispatch]);

  useEffect(() => {
    if (selectedExpand && !selectedExpand?.colourWayRefsData) {
      setBtnsDisable(true);
    }
    const Collection = [...supplierCollection];
    const filtered = selectedExpand && { ...selectedExpand };
    if (!isEmpty(filtered?.composition)) {
      filtered.composition = filtered.composition
        .sort((a, b) => b.percentage - a.percentage)
        .map((ele) => {
          if (ele?.percentage && ele?.composition) {
            return `${ele.percentage}% ${ele.composition?.name}`;
          }
          return null;
        });
    }
    forColourRefData(filtered, Collection);
    setState(filtered);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedExpand]);

  useEffect(() => {
    // effect
    setCurrentab(selectedTab);
  }, [selectedTab]);

  useEffect(() => {
    if (!isEmpty(supportingDocs)) {
      setSupportingDocsList(supportingDocs);
    }
  }, [supportingDocs]);

  useEffect(() => {
    const fetchSupportingDocuments = async () => {
      if (isSupportingOpen && state?._id && state?.bomType?._id) {
        const params = {
          bomType: state?.bomType?._id || state?.bomComponent?.bomTypeId || null,
          libId: state?.libId || state?._id || null,
          devOrderId: devOrderId || null,
        };
        await dispatch(getSupportingDocuments(params));
      }
    };
    fetchSupportingDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSupportingOpen, state?._id, state?.bomType?._id, devOrderId]);
  useEffect(() => {
    const callFn = async () => {
      await dispatch(getAllUnitDetails({ loggedInUserId: userInfo?.userId }));
    };
    if (userInfo?.userId) callFn();
  }, [dispatch, userInfo?.userId]);

  const forColourRefData = (filtered, Collection) => {
    if (!isEmpty(filtered?.colourWayRefsData)) {
      filtered?.colourWayRefsData?.forEach((item) => {
        item?.colourRefsDataAsPerSuppliers?.forEach((ele) => {
          const supplierUser = userInfo;
          const slugName = window.location.hostname?.split('.')?.[0];

          const supplierName = supplierUser?.userCompanies?.companiesList?.find((obj) => obj.companyName === slugName)?.supplierName;

          const canInclude =
            !isSupplierLoggedIn ||
            supplierName === ele?.componentSupplier?.name ||
            ele?.componentSupplier?.name === LOCALLY_SOURCED ||
            supplierName === ele?.tier1Supplier?.name;

          if (ele?.tier1Supplier && ele?.componentSupplier && canInclude) {
            Collection.push({
              supplier: ele.componentSupplier,
              details: [
                {
                  productSupplier: textValueCondition(ele.tier1Supplier),
                  parentId: item._id,
                  childId: ele._id,
                  colorName: item.colourWayId,
                  colourRef: ele.colourRef,
                  colourRefNumber: ele.colourRefNumber,
                  check: false,
                  status: ele.status,
                  approveBy: ele.approveBy,
                  statusCheck: false,
                  commentDate: ele?.commentDate?.toString(),
                  comment: ele.comment,
                  colourPlacement: ele?.colourPlacement,
                },
              ],
            });
          } else if (ele?.tier1Supplier && canInclude) {
            Collection.push({
              supplier: null,
              details: [
                {
                  productSupplier: textValueCondition(ele.tier1Supplier),
                  parentId: item._id,
                  childId: ele._id,
                  colorName: item.colourWayId,
                  colourRef: ele.colourRef,
                  colourRefNumber: ele.colourRefNumber,
                  check: false,
                  status: ele.status,
                  approveBy: ele.approveBy,
                  statusCheck: false,
                  commentDate: ele?.commentDate?.toString(),
                  comment: ele.comment,
                  colourPlacement: ele?.colourPlacement,
                },
              ],
            });
          } else if (canInclude) {
            Collection.push({
              supplier: ele?.componentSupplier || null,
              details: [
                {
                  productSupplier: { name: '' },
                  parentId: item._id,
                  childId: ele._id,
                  colorName: item.colourWayId,
                  colourRef: ele.colourRef,
                  colourRefNumber: ele.colourRefNumber,
                  check: false,
                  status: ele.status,
                  approveBy: ele.approveBy,
                  statusCheck: false,
                  commentDate: ele?.commentDate?.toString(),
                  comment: ele.comment,
                  colourPlacement: ele?.colourPlacement,
                },
              ],
            });
          }
        });
      });

      // Mapping logic remains similar
      const map = new Map();

      Collection.forEach(({ supplier, details }) => {
        if (supplier) {
          const key = supplier._id || supplier.name;
          if (!map.has(key)) {
            map.set(key, {
              id: key,
              name: textValueCondition(supplier.name),
              details: [],
            });
          }
          map.get(key).details.push(...[details].flat());
        } else {
          const colorKey = details[0].colourRef || details[0].childId;
          if (!map.has(colorKey)) {
            map.set(colorKey, {
              id: colorKey,
              name: '', // Empty name hides supplier section
              details: [],
            });
          }
          map.get(colorKey).details.push(...[details].flat());
        }
      });

      setSupplierCollection([...map.values()]);
    }
  };

  const handleApproval = async (value) => {
    const [id, devId, data] = value;
    if (!data.commentDate) {
      data.commentDate = moment().format();
    }
    const bomType = id?._id || id;
    const res = await dispatch(action.addColorApproval(bomType, devId, data, t));
    if (res) {
      await updateList();
      handleClose();
      setDisabledSaveBtn(false);
    }
  };

  const handleCollectColors = (mainIndex, index, status) => {
    const toogle = !status;
    const collection = [...supplierCollection];
    const selected = [...selectedColors];
    collection[mainIndex].details[index].check = toogle;
    setSupplierCollection(collection);
    const data = {
      ...collection[mainIndex].details[index],
      supplier: collection[mainIndex]?.id ? collection[mainIndex]?.id : '',
    };
    if (toogle) {
      selected.push(data);
    } else {
      const newObj = {
        ...collection[mainIndex].details[index],
        check: status,
        supplier: collection[mainIndex]?.id ? collection[mainIndex]?.id : '',
      };
      const position = selected.findIndex((item) => JSON.stringify(item) === JSON.stringify(newObj));
      if (position !== -1) {
        selected.splice(position, 1);
      }
    }
    setselectedColors(selected);
  };

  const handleDeleteQuality = async (item) => {
    const obj = {
      supplierId: item?.supplierId?._id ? item?.supplierId?._id : '',
      libId: state?.libId ? state?.libId : '',
      refCode: state?.referenceCode ? state?.referenceCode : '',
    };
    const bomTypeId = selectedTab?._id ? selectedTab?._id : '';
    const value = obj;
    const res = await dispatch(action.removeBomApproval(bomTypeId, devOrderId, value, t));
    if (res) {
      await updateList();
      handleClose();
    }
  };

  const handleSingleDelete = async (item) => {
    const value = {
      supplier: item?.supplier,
      parentId: item?.parentId,
      childId: item?.childId,
      colourRefNumber: item?.colourRefNumber,
      colourRef: item?.colourRef?._id ? item?.colourRef?._id : '',
    };
    const colourData = [value];
    const id = selectedTab?._id ? selectedTab?._id : '';
    const obj = {
      libId: state?.libId ? state?.libId : '',
      colourData,
      refCode: state?.referenceCode ? state?.referenceCode : '',
    };
    const res = await dispatch(action.removeColorApproval(id, devOrderId, obj));
    if (res) {
      await updateList();
      handleClose();
    }
  };
  const supplierUser = userInfo;
  const slugName = window.location.hostname?.split('.')?.[0];

  const supplierName = supplierUser?.userCompanies?.companiesList?.find((obj) => obj.companyName === slugName)?.supplierName;

  const joinbomSupps = (item) => {
    const compos = [];

    item.forEach((ele) => {
      if (!isSupplierLoggedIn || supplierName === ele.name || ele.name === LOCALLY_SOURCED) {
        compos.push(ele?.name);
      }
    });
    return compos.join(' , ');
  };

  const joinCombinationSupps = (item) => {
    const compos = [];
    item.forEach((ele) => {
      if (!isSupplierLoggedIn || supplierName === ele?.componentSupplier || ele?.componentSupplier === LOCALLY_SOURCED) {
        compos.push(ele?.componentSupplier);
      }
    });
    return compos.join(' , ');
  };

  /**
   * Downloads a supporting document from its ready-to-use presigned S3 URL.
   * getBOMDocs replaces each document's path with a presigned URL, so the value is fetched directly
   * (the same URL the preview iframe uses) rather than being rebuilt against the legacy /assets route.
   * @param {string} fileName Name to save the downloaded file as.
   * @param {string} filePath Presigned S3 URL of the document.
   * @returns {Promise<void>} Resolves once the download has been triggered or the failure surfaced.
   */
  const downloadDocument = async (fileName, filePath) => {
    const downloaded = await downloadFileFromUrl(filePath, fileName);
    if (!downloaded) {
      toasterMsg(t('SUPPORTING_DOCUMENTS_TABLE.DOWNLOAD_FAILED', 'Failed to download the file. Please try again.'), 'danger');
    }
  };

  const getPlacementName = (id) => {
    if (!id || !placement_master?.length) return '-';
    const option = placement_master.find((opt) => opt?._id === id);
    return option?.name || '-';
  };

  const getEnergySourceFromSupplier = (supplierId, tierType) => {
    if (!supplierId) return '-';
    const supplierIdValue = typeof supplierId === 'object' && supplierId !== null ? supplierId._id : supplierId;
    if (!supplierIdValue) return '-';

    let supplierList = [];
    if (tierType === 'tier2') {
      supplierList = tier2Suppliers || suppliersList || [];
    } else if (tierType === 'tier3') {
      supplierList = tier3Suppliers || [];
    } else if (tierType === 'tier4') {
      supplierList = tier4Suppliers || [];
    }

    const supplier = supplierList.find((supp) => supp._id === supplierIdValue);
    if (supplier?.factory?.[0]?.energySource) {
      return typeof supplier.factory[0].energySource === 'object' && supplier.factory[0].energySource !== null
        ? supplier.factory[0].energySource.value || '-'
        : supplier.factory[0].energySource || '-';
    }
    return '-';
  };

  const getEnergyIntensityFromSupplier = (supplierId, tierType) => {
    if (!supplierId) return '-';
    const supplierIdValue = typeof supplierId === 'object' && supplierId !== null ? supplierId._id : supplierId;
    if (!supplierIdValue) return '-';

    let supplierList = [];
    if (tierType === 'tier2') {
      supplierList = tier2Suppliers || suppliersList || [];
    } else if (tierType === 'tier3') {
      supplierList = tier3Suppliers || [];
    } else if (tierType === 'tier4') {
      supplierList = tier4Suppliers || [];
    }

    const supplier = supplierList.find((supp) => supp._id === supplierIdValue);
    return supplier?.factory?.[0]?.energyIntensity || '-';
  };

  const getQualityColour = (docItem) => {
    if (docItem?.docType === 'Colour' && docItem?.colourWay) {
      const colour = ColorLibList?.find((col) => col._id === docItem.colourWay || col._id === docItem.libId);
      return colour ? `Colour (${colour.name})` : 'Colour';
    }
    return docItem?.docType || 'Quality';
  };

  const openFilePreview = (doc) => {
    const params = {
      fileName: doc.fileName,
      mimeType: doc.mimeType,
      path: doc?.filePath ? doc?.filePath : doc?.path,
    };
    setFileToPreview(params);
    setFilePreviewModal(true);
  };

  const togglePreview = () => {
    setFilePreviewModal(!showFilePreviewModal);
  };

  const setImage = (image) => {
    let imagePath = '';
    if (image?.includes('data:image/')) {
      imagePath = image;
    } else if (image) {
      imagePath = image;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };

  return (
    <Modal show={show} className="right common-custom-modal card-expand-view" onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <span className="f-24">{state?.referenceCode ? hoverTooltip(state?.referenceCode, true) : ''}</span>
        </Modal.Title>
        <span onClick={handleClose} className="icon-close cursor-pointer ml-auto" />
      </Modal.Header>
      <Modal.Body className="expand-body">
        <div className="expand-card-container">
          <div className="top-container">
            <div className="image-container">
              <figure>
                <img alt="poster" src={src(state)} />
              </figure>
              <div className="content">
                <h4 className="expand-name">
                  <span className={state?.highlightedKeys?.includes('referenceCode') && highlightedField}>{textWithHoverCondition(state?.referenceCode)}</span>
                </h4>
                <p className="expand-description">
                  {state?.bomDescription?.length > 180 ? (
                    <OverlayTrigger
                      placement={t('TAKING_DATES.BUTTON')}
                      overlay={
                        <Tooltip className="text-tooltip" id="tooltip_description">
                          {state?.bomDescription}
                        </Tooltip>
                      }
                    >
                      <span>{`${shortenString(state?.bomDescription, 180)}...`}</span>
                    </OverlayTrigger>
                  ) : (
                    <span>{state?.bomDescription}</span>
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="bottom-container">
            <div className="common-custom-scrollbar" style={{ maxHeight: '100%', overflow: 'auto' }}>
              <ul className="bom-expand-list">
                <li>
                  <span className="expand-title-text">{t('TAKING_DATES.TYPE')} </span>
                  <span className={state?.highlightedKeys?.includes('bomSubType') && highlightedField}>{textValueCondition(state?.bomSubType?.name)}</span>
                </li>
                <li>
                  <span className="expand-title-text">{t('TAKING_DATES.DESP')}</span>
                  <span className={state?.highlightedKeys?.includes('bomDescription') && highlightedField}>
                    {state?.bomDescription?.length > 78 ? (
                      <OverlayTrigger
                        placement={t('TAKING_DATES.BUTTON')}
                        overlay={
                          <Tooltip className="text-tooltip" id="tooltip_description">
                            {state?.bomDescription}
                          </Tooltip>
                        }
                      >
                        <span className="pl-1">{`${shortenString(state?.bomDescription, 78)}...`}</span>
                      </OverlayTrigger>
                    ) : (
                      <span className="pl-1">{state?.bomDescription}</span>
                    )}
                  </span>
                </li>

                <li>
                  <span className="expand-title-text">{t('TAKING_DATES.COMPONENET_SUPPLER')}:</span>
                  <span className={state?.highlightedKeys?.includes('BOMSupplier') && highlightedField}>
                    <span className="pl-1">
                      {forBomSupps(state, joinbomSupps)}
                      {forCombinationSupps(state, joinCombinationSupps)}
                    </span>
                  </span>
                </li>
                <li>
                  <span className="expand-title-text">{t('TAKING_DATES.PLACEMENTWITHCOL')}</span>{' '}
                  <span className={state?.highlightedKeys?.includes('newPlacement') && highlightedField}>
                    {textValueCondition(state?.newPlacement?.map((item) => item.name).join(', '))}
                  </span>
                </li>
                <li>
                  <div className="row">
                    <div className="col-sm-6 text-truncate">
                      <span className="expand-title-text pl-0">{t('TAKING_DATES.COMPOSITIONCOL')}</span>{' '}
                      <span className={state?.highlightedKeys?.includes('composition') && highlightedField}>
                        {!isEmpty(state?.composition) && shortenStringWithTooltip(state?.composition?.join(','), 78)}
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="row">
                    <div className="col-sm-4 bom-data-text">
                      <div className="expand-title-text">{t('TAKING_DATES.WEIGHTCOL')}</div>
                      <span className={state?.highlightedKeys?.includes('weight') ? `${highlightedField} d-block mt-2` : 'd-block mt-2'}>
                        {`${textValueCondition(state?.weight)} ${textNoValueCondition(state?.weightUnitOfMeasure?.name)}`}
                      </span>
                    </div>
                    <div className="col-sm-4 bom-data-text">
                      <div className="expand-title-text">{t('TAKING_DATES.SIZECOL')}</div>
                      <span className={state?.highlightedKeys?.includes('size') ? `${highlightedField} d-block mt-2` : 'd-block mt-2'}>
                        {`${textValueCondition(state?.size)} ${textNoValueCondition(state?.sizeUnitOfMeasure?.name)}`}
                      </span>
                    </div>
                    <div className="col-sm-4 bom-data-text">
                      <div className="expand-title-text">{t('TAKING_DATES.QUANTCOL')}</div>{' '}
                      <span className={state?.highlightedKeys?.includes('quantity') ? `${highlightedField} d-block mt-2` : 'd-block mt-2'}>
                        {`${textValueCondition(state?.quantity)} ${textNoValueCondition(state?.quantityUnitOfMeasure?.name)}`}
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="row">
                    <div className="col-sm-6 bom-data-text">
                      <div className="expand-title-text">{t('TAKING_DATES.PRICE_PER_UNIT')}</div>{' '}
                      <span
                        className={
                          state?.highlightedKeys?.includes('pricePerUnit') || state?.highlightedKeys?.includes('pricePerUnitCurrency')
                            ? `${highlightedField} d-block mt-2`
                            : 'd-block mt-2'
                        }
                      >
                        {`${textValueCondition(state?.pricePerUnit)} ${textNoValueCondition(state?.pricePerUnitCurrency)}`}
                      </span>
                    </div>
                    <div className="col-sm-6 bom-data-text ">
                      <div className="expand-title-text">{t('TAKING_DATES.FINISHCOL')}</div>
                      <span className={state?.highlightedKeys?.includes('finished') ? `${highlightedField} d-block mt-2` : 'd-block mt-2'}>
                        {typeof state?.finished === 'string' ? state?.finished : `${textValueCondition(state?.finished?.name)}`}
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <span className="expand-title-text">{t('TAKING_DATES.ADDITIONAL')} </span>{' '}
                  <p className={state?.highlightedKeys?.includes('additionalInfo') && highlightedField}>
                    <textarea value={state?.additionalInfo} className="additional-info-text text-book" rows="8" readOnly />
                  </p>
                </li>
                {state?.dynamicColumn
                  ?.filter((dynAttr) => dynAttr?.colId?.isActive !== false)
                  ?.map((dynAttr, idx) => {
                    const label = dynAttr?.colId?.keyName || dynAttr?.keyName || '-';
                    let value = '-';
                    if (dynAttr?.valueText) value = dynAttr.valueText;
                    else if (dynAttr?.valueId?.keyName) value = dynAttr.valueId.keyName;
                    else if (dynAttr?.colId?.type === 'Multi Dropdown' && dynAttr?.valueId?.length > 0)
                      value = dynAttr?.valueId?.map((v) => v?.keyName).join(', ');
                    return (
                      <li key={`dyn-${idx}`}>
                        <span className="expand-title-text">{label}:</span> <span>{textValueCondition(value)}</span>
                      </li>
                    );
                  })}
                <li>
                  <span className="expand-title-text">{t('TAKING_DATES.TAG')}</span> {selectedExpand?.tags?.join(',')}
                </li>
                <li>
                  <span className="expand-title-text">{t('PROGRESS_INDICATOR.CREATE')}</span>{' '}
                  <span>
                    {textValueCondition(state?.createdBy)} {state?.createdAt ? moment(state?.createdAt).format(dateFormat) : ''}
                  </span>
                </li>
                <li>
                  <span className="expand-title-text">{t('PROGRESS_INDICATOR.MODIFI')}</span>{' '}
                  {state?.modifiedBy && state?.updatedAt ? (
                    <span>
                      {state.modifiedBy} {moment(state.updatedAt).format(dateFormat)}{' '}
                    </span>
                  ) : (
                    createdBY(state)
                  )}
                </li>
              </ul>

              <Card className="mt-2 ml-16 mb-16 mr-16 bom-add-card">
                <Card.Header onClick={() => setIsSubBomOpen((prev) => !prev)} className="d-flex bom-subcard-header justify-content-between align-items-center">
                  <span className="bom-subheader text-bold">Sub - BOM</span>
                  <span className={isSubBomOpen ? 'cursor-pointer icon-new-down-arrow-icon icon-inverse' : 'cursor-pointer icon-new-down-arrow-icon'} />
                </Card.Header>
                <Collapse in={isSubBomOpen}>
                  <div>
                    <Card.Body className="">
                      <div className="table-responsive">
                        <table className="table custom-table sub-bom-expand-table  layout-fixed font-13">
                          <thead>
                            <tr>
                              <th className="w-80px text-left">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.IMAGE')}</th>
                              <th className="w-100px text-left  last-fix-col"> {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_CODE')}</th>
                              <th className="w-100px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_DESCRIPTION')}</th>
                              <th className="w-100px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUPLIER')}</th>
                              <th className="w-100px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_TYPE')}</th>
                              <th className="w-100px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUB_TYPE')}</th>
                              <th className="w-100px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SIZE/UOM')}</th>
                              <th className="w-100px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.WEIGHT/UOM')}</th>
                              <th className="w-100px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.QUANTITY/UOM')}</th>
                              <th className="w-100px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.FINISH')}</th>
                              <th className="w-100px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION')}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {state?.subBomList
                              ?.filter((row) => !row?.isDeleted)
                              .map((row, index) => (
                                <tr key={row?._id || index}>
                                  <td className="text-left">
                                    <div className="image-container mr-0">
                                      <div className="image-border">
                                        <img width="48" height="48" src={setImage(row?.image)} alt={row?.referenceCode || ''} />
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-left  last-fix-col">{textValueCondition(row?.referenceCode)}</td>
                                  <td className="text-left">{textValueCondition(row?.bomDescription)}</td>
                                  <td className="text-left">{textValueCondition(row?.BOMSupplier?.name)}</td>
                                  <td className="text-left">{textValueCondition(row?.bomComponentType?.name)}</td>
                                  <td className="text-left">{textValueCondition(row?.bomComponentSubType?.name)}</td>
                                  <td className="text-left">
                                    {textValueCondition(row?.size)} {unitList?.find((item) => item._id === row?.sizeUnitOfMeasure)?.name}
                                  </td>
                                  <td className="text-left">
                                    {textValueCondition(row?.weight)} {unitList?.find((item) => item._id === row?.weightUnitOfMeasure)?.name}
                                  </td>
                                  <td className="text-left">
                                    {textValueCondition(row?.quantity)} {unitList?.find((item) => item._id === row?.quantityUnitOfMeasure)?.name}
                                  </td>
                                  <td className="text-left">{finalList?.map((item) => (item._id === row?.finished ? item.name : ''))}</td>
                                  <td className="text-left">
                                    {row?.composition
                                      ?.filter((item) => item?.percentage !== null && item?.composition?.name !== null)
                                      .map((item) => `${item?.percentage}% ${item?.composition?.name}`)
                                      .join(', ')}
                                  </td>
                                </tr>
                              ))}
                            {state?.subBomList?.length === 0 && (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.NO_DATA_AVAILABLE')}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Card.Body>
                  </div>
                </Collapse>
              </Card>
              <Card className="mt-2 ml-16 mb-16 mr-16 bom-add-card">
                <Card.Header
                  onClick={() => setIsProductImpactOpen((prev) => !prev)}
                  className=" bom-subcard-header d-flex justify-content-between align-items-center"
                >
                  <span className="bom-subheader text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.BOM_PRODUCT_IMPACT')}</span>
                  <span className={isProductImpactOpen ? 'cursor-pointer icon-new-down-arrow-icon icon-inverse' : 'cursor-pointer icon-new-down-arrow-icon'} />
                </Card.Header>
                <Collapse in={isProductImpactOpen}>
                  <div>
                    <Card.Body className="p-3">
                      {state?.productImpact ? (
                        <div className="product-impact-container">
                          {state?.productImpact?.tierOne && (
                            <div className="mb-4 bom-expand-impact-section">
                              <div className="highlight-form mb-0 common-input-control">
                                <p className="f-14 h-20 mb-0 text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_TIER_ONE')}</p>
                                <input
                                  type="text"
                                  name="tierOne"
                                  readOnly
                                  value={
                                    state?.productImpact?.tierOne ? suppliersList?.find((supp) => supp._id === state.productImpact.tierOne)?.name || '-' : '-'
                                  }
                                  className="form-control"
                                />
                              </div>
                            </div>
                          )}
                          {state?.productImpact?.tierTwo && (
                            <div className="mb-16 bom-expand-impact-section tier-two-section">
                              <p className="mb-0 f-14 text-bold">{t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TIER_TWO')}</p>
                              <div className="mb-16">
                                <p className="mb-0 f-14 text-book">
                                  {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.POST_PROCESSING_SENTENCE')}
                                  <span className="ml-2">
                                    {state.productImpact.tierTwo.postProcessingAnotherLocation === 'yes' ? t('COMMON_LABEL.YES') : t('COMMON_LABEL.NO')}
                                  </span>
                                </p>
                              </div>

                              {state.productImpact.tierTwo.postProcessingAnotherLocation === 'yes' && (
                                <div className="mb-16">
                                  <p className="mb-2 f-14 text-book">
                                    {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.POST_PROCESSING_GOODS_SENTENCE')}
                                    <span className="ml-2">
                                      {state.productImpact.tierTwo.finishedProductAssemblySupp === 'finishedProductAssemblySupplier'
                                        ? t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.FINSIH_PRODUCT_ASSEMBLY')
                                        : t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.COMPOENENT_SUPPLIER')}
                                    </span>
                                  </p>
                                </div>
                              )}

                              {state?.productImpact.tierTwo.componentSupplierObj && (
                                <div className="row mb-16">
                                  <div className="col-md-6">
                                    <div className="highlight-form mb-0 common-input-control">
                                      <p className="f-14 mb-0 h-20 text-bold">
                                        {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.COMPOENENT_SUPPLIER')} <span className="asterisk">*</span>
                                      </p>
                                      <input
                                        type="text"
                                        name="componentSupplier"
                                        readOnly
                                        value={
                                          tier2Suppliers?.find(
                                            (data) =>
                                              data._id ===
                                              (state?.productImpact?.tierTwo?.componentSupplierObj?.componentSupplier?._id ??
                                                state?.productImpact?.tierTwo?.componentSupplierObj?.componentSupplier),
                                          )?.name || '-'
                                        }
                                        className="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="highlight-form mb-0 common-input-control">
                                      <p className="f-14 mb-0 h-20 text-bold">
                                        {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_SOURCE')} <span className="asterisk">*</span>
                                      </p>
                                      <input
                                        type="text"
                                        name="energySource"
                                        readOnly
                                        value={getEnergySourceFromSupplier(state?.productImpact?.tierTwo?.componentSupplierObj?.componentSupplier, 'tier2')}
                                        className="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="highlight-form mb-0 common-input-control">
                                      <p className="f-14 mb-0 h-20 text-bold">
                                        {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_INTENSITY')} <span className="asterisk">*</span>
                                      </p>
                                      <input
                                        type="text"
                                        name="energyIntensity"
                                        readOnly
                                        value={getEnergyIntensityFromSupplier(state?.productImpact?.tierTwo?.componentSupplierObj?.componentSupplier, 'tier2')}
                                        className="form-control"
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="row mb-16">
                                <div className="col-md-6">
                                  <div className="highlight-form mb-0 common-input-control">
                                    <p className="f-14 mb-0 h-20 text-bold">
                                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TRASPORT_POST_PROCESSING_SUPPLIER')} <span className="asterisk">*</span>
                                    </p>
                                    <input
                                      type="text"
                                      name="transport"
                                      readOnly
                                      value={state?.productImpact?.tierTwo?.componentSupplierObj?.transport?.label || '-'}
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="highlight-form mb-0 common-input-control">
                                    <p className="f-14 mb-0 h-20 text-bold">
                                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.PROCESSES')} <span className="asterisk">*</span>
                                    </p>
                                    <input
                                      type="text"
                                      name="bomProcessType"
                                      readOnly
                                      value={state?.productImpact?.tierTwo?.componentSupplierObj?.bomProcessType?.map((item) => item.name).join(', ') || '-'}
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                              </div>

                              {state.productImpact.tierTwo.componentPostProcessing && state.productImpact.tierTwo.postProcessingAnotherLocation === 'yes' && (
                                <>
                                  <div className="row mb-16">
                                    <div className="col-md-6">
                                      <div className="highlight-form mb-0 common-input-control">
                                        <p className="f-14 mb-0 h-20 text-bold">
                                          {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.POST_PROCESSING_SUPPLIER')} <span className="asterisk">*</span>
                                        </p>
                                        <input
                                          type="text"
                                          name="postProcessingSupp"
                                          readOnly
                                          value={
                                            tier2Suppliers?.find(
                                              (data) =>
                                                data._id === state?.productImpact?.tierTwo?.componentPostProcessing?.postProcessingSupp?._id ||
                                                data._id === state?.productImpact?.tierTwo?.componentPostProcessing?.postProcessingSupp,
                                            )?.name || '-'
                                          }
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="highlight-form mb-0 common-input-control">
                                        <p className="f-14 mb-0 h-20 text-bold">
                                          {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_SOURCE')} <span className="asterisk">*</span>
                                        </p>
                                        <input
                                          type="text"
                                          name="energySource"
                                          readOnly
                                          value={getEnergySourceFromSupplier(
                                            state?.productImpact?.tierTwo?.componentPostProcessing?.postProcessingSupp,
                                            'tier2',
                                          )}
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="highlight-form mb-0 common-input-control">
                                        <p className="f-14 mb-0 h-20 text-bold">
                                          {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_INTENSITY')} <span className="asterisk">*</span>
                                        </p>
                                        <input
                                          type="text"
                                          name="energyIntensity"
                                          readOnly
                                          value={getEnergyIntensityFromSupplier(
                                            state?.productImpact?.tierTwo?.componentPostProcessing?.postProcessingSupp,
                                            'tier2',
                                          )}
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-16">
                                    <div className="col-md-6">
                                      <div className="highlight-form mb-0 common-input-control">
                                        <p className="f-14 mb-0 h-20 text-bold">
                                          {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TRASPORT_POST_PROCESSING_SUPPLIER')} <span className="asterisk">*</span>
                                        </p>
                                        <input
                                          type="text"
                                          name="transport"
                                          readOnly
                                          value={state?.productImpact?.tierTwo?.componentPostProcessing?.transport?.label || '-'}
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="highlight-form mb-0 common-input-control">
                                        <p className="f-14 mb-0 h-20 text-bold">
                                          {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.PROCESSES')} <span className="asterisk">*</span>
                                        </p>
                                        <input
                                          type="text"
                                          name="bomProcessType"
                                          readOnly
                                          value={
                                            state?.productImpact?.tierTwo?.componentPostProcessing?.bomProcessType?.map((item) => item.name).join(', ') || '-'
                                          }
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                          {state?.productImpact?.tierThree && (
                            <div className="mb-4 bom-expand-impact-section tier-three-section">
                              <p className="mb-0 f-14 text-bold">{t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TIER_THRE')}</p>
                              <div className="mb-16">
                                <p className="mb-0 text-book">
                                  {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.RAW_MATERIAL_EXTRACTORE')}
                                  <span className="ml-2">
                                    {state?.productImpact?.tierThree?.rawMaterialProcessorExtractor === 'yes' ? t('COMMON_LABEL.YES') : t('COMMON_LABEL.NO')}
                                  </span>
                                </p>
                              </div>

                              {state?.productImpact?.tierThree?.rawMaterialProcessor && (
                                <div className="row mb-16">
                                  <div className="col-md-6">
                                    <div className="highlight-form mb-0 common-input-control">
                                      <p className="f-14 mb-0 h-20 text-bold">
                                        {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.RAW_MATERIAL_PROCESSOR')} <span className="asterisk">*</span>
                                      </p>
                                      <input
                                        type="text"
                                        name="rawMaterialProcessor"
                                        readOnly
                                        value={
                                          tier3Suppliers?.find(
                                            (data) =>
                                              data._id === state?.productImpact?.tierThree?.rawMaterialProcessor?._id ||
                                              data._id === state?.productImpact?.tierThree?.rawMaterialProcessor,
                                          )?.name || '-'
                                        }
                                        className="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="highlight-form mb-0 common-input-control">
                                      <p className="f-14 mb-0 h-20 text-bold">
                                        {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_SOURCE')} <span className="asterisk">*</span>
                                      </p>
                                      <input
                                        type="text"
                                        name="energySource"
                                        readOnly
                                        value={getEnergySourceFromSupplier(state?.productImpact?.tierThree?.rawMaterialProcessor, 'tier3')}
                                        className="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="highlight-form mb-0 common-input-control">
                                      <p className="f-14 mb-0 h-20 text-bold">
                                        {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_INTENSITY')} <span className="asterisk">*</span>
                                      </p>
                                      <input
                                        type="text"
                                        name="energyIntensity"
                                        readOnly
                                        value={getEnergyIntensityFromSupplier(state?.productImpact?.tierThree?.rawMaterialProcessor, 'tier3')}
                                        className="form-control"
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                              {state.productImpact.tierThree.transport && (
                                <div className="row mb-3">
                                  <div className="col-md-6">
                                    <div className="highlight-form mb-0 common-input-control">
                                      <p className="f-14 mb-0 h-20 text-bold">
                                        {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TRASPORT_POST_PROCESSING_SUPPLIER')} <span className="asterisk">*</span>
                                      </p>
                                      <input
                                        type="text"
                                        name="transport"
                                        readOnly
                                        value={state?.productImpact?.tierThree?.transport?.label || '-'}
                                        className="form-control"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="highlight-form mb-0 common-input-control">
                                      <p className="f-14 mb-0 h-20 text-bold">
                                        {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.PROCESSES')} <span className="asterisk">*</span>
                                      </p>
                                      <input
                                        type="text"
                                        name="bomProcessType"
                                        readOnly
                                        value={state?.productImpact?.tierThree?.bomProcessType?.map((item) => item.name).join(', ') || '-'}
                                        className="form-control"
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          {state?.productImpact?.tierFour && (
                            <div className="mb-3 bom-expand-impact-section tier-three-section">
                              <p className="mb-0 f-14 text-bold">{t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TIER_FOUR')}</p>

                              <div className="row mb-16">
                                <div className="col-md-6">
                                  <div className="highlight-form mb-0 common-input-control">
                                    <p className="field-name text-bold">
                                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.RAW_MATERIAL_PROCESSOR')} <span className="asterisk">*</span>
                                    </p>
                                    <input
                                      type="text"
                                      name="rawMaterialExtractor"
                                      readOnly
                                      value={
                                        tier4Suppliers?.find(
                                          (data) =>
                                            data._id === state?.productImpact?.tierFour?.rawMaterialExtractor?._id ||
                                            data._id === state?.productImpact?.tierFour?.rawMaterialExtractor,
                                        )?.name || '-'
                                      }
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="highlight-form mb-0 common-input-control">
                                    <p className="f-14 mb-0 h-20 text-bold">
                                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_SOURCE')} <span className="asterisk">*</span>
                                    </p>
                                    <input
                                      type="text"
                                      name="energySource"
                                      readOnly
                                      value={getEnergySourceFromSupplier(state?.productImpact?.tierFour?.rawMaterialExtractor, 'tier4')}
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="highlight-form mb-0 common-input-control">
                                    <p className="f-14 mb-0 h-20 text-bold">
                                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_INTENSITY')} <span className="asterisk">*</span>
                                    </p>
                                    <input
                                      type="text"
                                      name="energyIntensity"
                                      readOnly
                                      value={getEnergyIntensityFromSupplier(state?.productImpact?.tierFour?.rawMaterialExtractor, 'tier4')}
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row mb-16">
                                <div className="col-md-6">
                                  <div className="highlight-form mb-0 common-input-control">
                                    <p className="f-14 mb-0 h-20 text-bold">
                                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TRASPORT_POST_PROCESSING_SUPPLIER')} <span className="asterisk">*</span>
                                    </p>
                                    <input
                                      type="text"
                                      name="transport"
                                      readOnly
                                      value={state?.productImpact?.tierFour?.transport?.label || '-'}
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="highlight-form mb-0 common-input-control">
                                    <p className="f-14 mb-0 h-20 text-bold">
                                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.PROCESSES')} <span className="asterisk">*</span>
                                    </p>
                                    <input
                                      type="text"
                                      name="compositionProcessType"
                                      readOnly
                                      value={state?.productImpact?.tierFour?.compositionProcessType?.map((item) => item.name).join(', ') || '-'}
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="text-center py-4">
                          <p>{t('ERROR_MESSAGES.NO_DATA_AVAILABLE')}</p>
                        </div>
                      )}
                    </Card.Body>
                  </div>
                </Collapse>
              </Card>
              <Card className="mt-2 ml-16 mb-16 mr-16 bom-add-card">
                <Card.Header
                  onClick={() => setIsSupportingOpen((prev) => !prev)}
                  className="bom-subcard-header d-flex justify-content-between align-items-center"
                >
                  <span className="bom-subheader text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUPPORTING_DOCUMENT')}</span>
                  <span className={isSupportingOpen ? 'cursor-pointer icon-new-down-arrow-icon icon-inverse' : 'cursor-pointer icon-new-down-arrow-icon'} />
                </Card.Header>
                <Collapse in={isSupportingOpen}>
                  <div>
                    <Card.Body className="p-3">
                      {loadingDocs && (
                        <div className="text-center py-4">
                          <p>{t('COMMON_LABEL.LOADING')}</p>
                        </div>
                      )}
                      {!loadingDocs && isEmpty(supportingDocsList) && (
                        <div className="text-center py-4">
                          <p>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.NO_DATA_AVAILABLE')}</p>
                        </div>
                      )}
                      {!loadingDocs && !isEmpty(supportingDocsList) && (
                        <div className="p-0 overRight-x">
                          <Table className="table p-0 common-custom-table">
                            <thead className="light-grey text-center">
                              <tr className="support-doc-head">
                                <th className="w-150px f-14 common-data-head">{t('SUPPORTING_DOCUMENTS_TABLE.DOCUMENT_NAME')}</th>
                                <th className="w-75px f-14 common-data-head">{t('SUPPORTING_DOCUMENTS_TABLE.TYPE')}</th>
                                <th className="w-100px f-14 common-data-head">{t('SUPPORTING_DOCUMENTS_TABLE.QUALITY_COLOUR')}</th>
                                <th className="w-100px f-14 common-data-head">{t('ADD_SUPPORTING_DOCUMENT.REFERENCE')}</th>
                                <th className="w-100px f-14 common-data-head">{t('ADD_SUPPORTING_DOCUMENT.PLACEMENT')}</th>
                                <th className="w-50px f-14 common-data-head" />
                              </tr>
                            </thead>
                            <tbody className="tabbody">
                              {supportingDocsList.map((doc) => (
                                <tr key={doc?._id}>
                                  <td className="text-center f-14">{doc?.fileName || '-'}</td>
                                  <td className="text-center">
                                    <span className="text-capitalize f-14">{doc?.documentType || '-'}</span>
                                  </td>
                                  <td className="text-center f-14">{getQualityColour(doc)}</td>
                                  <td className="text-center f-14">
                                    <span className="text-capitalize f-14">{doc?.reference?.name || '-'}</span>
                                  </td>
                                  <td className="text-center f-14">
                                    <span className="text-capitalize">{getPlacementName(doc?.placement) || '-'}</span>
                                  </td>
                                  <td className="text-right f-14">
                                    <div className="d-flex align-items-center justify-content-end bom-doc-table-action">
                                      {doc?.documentType !== 'link' ? (
                                        <>
                                          <CustomTooltip placement="top" tooltipText={t('SUPPORTING_DOCUMENTS_TABLE.FILE_PREVIEW')}>
                                            <button type="button" aria-label="Preview" onClick={() => openFilePreview(doc)} className="btn bom-action-icon">
                                              <i className="icon-Preview-Document" />
                                            </button>
                                          </CustomTooltip>
                                          <CustomTooltip placement="top" tooltipText={t('SUPPORTING_DOCUMENTS_TABLE.DOWNLOAD_TOOLTIP')}>
                                            <button
                                              type="button"
                                              aria-label="Download"
                                              onClick={() => downloadDocument(doc.fileName, doc?.filePath ? doc.filePath : doc.path)}
                                              className="btn bom-action-icon"
                                            >
                                              <i className="icon-Download f-20" />
                                            </button>
                                          </CustomTooltip>
                                        </>
                                      ) : (
                                        <CustomTooltip placement="top" tooltipText={t('SUPPORTING_DOCUMENTS_TABLE.OPEN_URL')}>
                                          <button aria-label="detail_page" type="button" className="btn bom-action-icon">
                                            <a className="cursor-pointer text-dark text-decoration-none" target="_blank" href={doc?.linkUrl} rel="noreferrer">
                                              <i className="icon-Link-Bold-2 f-22" />
                                            </a>
                                          </button>
                                        </CustomTooltip>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </Card.Body>
                  </div>
                </Collapse>
              </Card>
              {!isEmpty(state?.bomApprovals) ? (
                <Card className="mt-1 bom-material-card material-quality-card">
                  <Card.Header className="ml-16 mr-16">
                    {currentab?.name} {t('TAKING_DATES.QUALITY_APPROVAL')}
                  </Card.Header>
                  <Card.Body>
                    {state.bomApprovals.map((item, index) => (
                      <div className="quality-approval-card approval-section" key={index}>
                        {item?.supplierId?.name && <p className="title">{item?.supplierId?.name}</p>}
                        <p className="status">
                          <div className="bom-expand-common-text">
                            <span className={`${colourClassName(item)} bom-expand-common-text text-book`}>
                              {item?.status === 1 ? 'Approved:' : statusText()}
                            </span>{' '}
                            by {item?.approveBy ? item?.approveBy : 'NA'} |<i />
                            &nbsp;
                            {item?.commentDate ? moment(item?.commentDate).format('DD-MMMM-yyyy') : ''}
                          </div>
                        </p>
                        {!isEmpty(item.comment) && (
                          <div className="comment-expand">
                            <p className="comment text-medium">{t('TAKING_DATES.APPROVAL_REJECTION')}</p>
                            <span className="comment-data-item text-book">{item?.comment}</span>
                          </div>
                        )}
                        {!isSupplierLoggedIn && !isProductArchived && BomApproveRejectAccess && (
                          <div className="d-flex justify-content-end">
                            <button type="button" aria-label="save" className="btn p-0 save-configure-bom" onClick={() => handleDeleteQuality(item)}>
                              <i className="icon-Delete" />
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </Card.Body>
                </Card>
              ) : null}
              {checkArray(colourwayExist) &&
                !isEmpty(supplierCollection) &&
                supplierCollection?.map((item, number) => (
                  <Card className="color-card bom-color-status" key={item?._id}>
                    <Card.Header className="ml-16 mr-16">Colour Status</Card.Header>
                    <Card.Body>
                      {item?.details?.map((ele, i) => (
                        <React.Fragment key={ele?._id}>
                          <div className="color-container expand-color-bom">
                            <div className="top">
                              <figure className="mr-0">{imgSrc(ele, colorLibList)}</figure>
                              <ul className="color-list-status w-100 row m-0">
                                {item?.name && (
                                  <li className="col-md-3 color-ref-data bom-expand-common-text">
                                    <div className="supp-name">{item?.name}</div>
                                  </li>
                                )}
                                <li className="col-md-3 d-block color-ref-data">
                                  <span className="colorway-name">{t('TAKING_DATES.COLOURS')}</span>
                                  <div className="colourway-sub-name">{textValueCondition(ele?.colorName?.name)}</div>
                                </li>
                                {item.details[i].productSupplier.name && (
                                  <li className="col-md-3 color-ref-data">
                                    <span className="prod-name">{t('TAKING_DATES.PRODUCT_SUPLIERS')}</span>
                                    <div className="colourway-sub-name">{item.details[i].productSupplier.name}</div>
                                  </li>
                                )}
                                <li className="col-md-3 color-ref-data">
                                  <span className="prod-name">{t('TAKING_DATES.COLOUR_PLACEMENT')}</span>
                                  <div className="colourway-sub-name">{item.details[i]?.colourPlacement?.name || '--'}</div>
                                </li>
                              </ul>
                            </div>
                            <div className="bottom">
                              {showColorWayCheckBox && BomApproveRejectAccess ? (
                                <div className="common-checkbox mb-2 size-sm">
                                  <input
                                    type="checkbox"
                                    id={`vehicle${number}${i}`}
                                    name="vehicle1"
                                    onChange={() => handleCollectColors(number, i, ele.check)}
                                    checked={ele.check}
                                    disabled={isProductArchived || isSupplierLoggedIn}
                                  />
                                  <label htmlFor={`vehicle${number}${i}`} className="chklabel">
                                    <span className="color-ref color-ref-data">{t('TAKING_DATES.COLOR_ART')}</span>
                                    <span className="ml-2 colourway-artwork-name color-ref-data">{joinedColourRef(ele)}</span>
                                  </label>
                                </div>
                              ) : (
                                <div className="checkbox-label">
                                  <span>
                                    <b>{t('TAKING_DATES.COLOR_ART')}</b>
                                  </span>
                                  <span>{joinedColourRef(ele)}</span>
                                </div>
                              )}
                              {showColorWayCheckBox && (ele?.status === 1 || ele?.status === 0) && (
                                <div className="hex-color">
                                  {ele?.colourRefNumber && <div className="status-ref-number">{textValueCondition(ele?.colourRefNumber)}</div>}
                                  <div className="common-checkbox">
                                    <div className="approval-color-status d-flex justify-content-between align-items-center">
                                      <div>
                                        <span className="text-medium mr-1 bom-expand-common-text">{t('TAKING_DATES.STATESCOL')}</span>
                                        <span className={`${colourClassName(ele)} f-14 text-book `}>{ele?.status === 1 ? 'Approved' : statusText()}</span>
                                        <i className="text-book">
                                          {' '}
                                          by {ele?.approveBy?.firstName ? ele?.approveBy?.firstName : 'NA'} <i />
                                          {ele?.approveBy?.lastName ? ele?.approveBy?.lastName : ''} |<i />
                                          &nbsp; {ele?.commentDate && moment(ele?.commentDate).format('DD-MMM-yyyy')}
                                        </i>
                                      </div>
                                    </div>
                                    {/* </label> */}
                                  </div>
                                  {!isEmpty(ele?.comment) && (
                                    <div className="comment-expand">
                                      <p className="bom-expand-common-text mb-0 text-medium">{t('TAKING_DATES.APPROVAL_REJECTION')}</p>
                                      <span className="bom-expand-common-text text-book">{ele?.comment}</span>
                                    </div>
                                  )}
                                  {BomApproveRejectAccess && !isSupplierLoggedIn && (
                                    <div className="d-flex justify-content-end">
                                      <button
                                        aria-label="delete"
                                        type="button"
                                        className="btn save-configure-bom ml-auto"
                                        onClick={() => handleSingleDelete(ele)}
                                      >
                                        <i className="icon-Delete f-16" />
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      ))}
                    </Card.Body>
                  </Card>
                ))}
            </div>
          </div>
        </div>
      </Modal.Body>
      {BomApproveRejectAccess && (
        <Modal.Footer>
          {showApprovedReject && !isSupplierLoggedIn && !isProductArchived && (
            <NewApproveRejectFooter
              hideSupplier
              devOrderId={devOrderId}
              selectedTab={selectedTab}
              suppliersList={suppliersList}
              onSave={(...data) => handleApproval(data)}
              selectedIdArray={selectedColors}
              selectedExpand={selectedExpand}
              disabledSaveBtn={disabledSaveBtn}
              selectedRefCode={textValueCondition(state?.referenceCode)}
              fromBomExpand
              btnsDisable={btnsDisable}
            />
          )}
        </Modal.Footer>
      )}
      {showFilePreviewModal && <FilePreview onOpen={showFilePreviewModal} fileObj={selectedFileToPreview} toggle={togglePreview} />}
    </Modal>
  );
}

export default BomExpand;
